import { ColdStartError, endpoints } from "@/api";
import type { CalculationResult, ContractInput } from "@/types";

import type { CalculationService } from "../interfaces";

/**
 * REST-backed calculation service — wraps the API client and applies the
 * cold-start retry logic from spec §7.2 Layer 3.
 *
 * If the backend returns HTML (Render's cold-start "Service unavailable"
 * page), apiFetch raises ColdStartError. We wait 5 s for the boot to
 * finish, then retry exactly once.
 */
export class RestCalculationService implements CalculationService {
  async calculate(input: ContractInput): Promise<CalculationResult> {
    try {
      const response = await endpoints.calculate({ contract: input });
      return response.data;
    } catch (err) {
      if (err instanceof ColdStartError) {
        await new Promise((resolve) => setTimeout(resolve, 5000));
        const response = await endpoints.calculate({ contract: input });
        return response.data;
      }
      throw err;
    }
  }
}
